import React from "react";
import { Col, Card, CardBody } from "reactstrap";
import contactUsSvg from "../assets/Contact_Us_Icon.svg";
import ContactIcon from "./ContactIcon";
import { useTranslation } from "react-i18next";

const ContactUsBlock = () => {
    const { t } = useTranslation();
    const contactUsSvgPath = contactUsSvg;
    return (
        <Col className="px-0" >
            <Card className="mb-3 shadow border-lt">
                <CardBody style={{ paddingLeft: 32, paddingRight: 32, paddingTop: 4, paddingBottom: 4 }}>
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <h5 className="mb-2" style={{ color: "var(--brand-navy)" }}>
                            {t("ContactUsBlock-prompt")}
                        </h5>
                        <ContactIcon src={contactUsSvgPath} width={70} />
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default ContactUsBlock;